<template>
  <div class="radio-form">
    <div class="radio-field" v-for="option in questionOptions">
      <input
        type="radio"
        :id="'radio-' + option.id"
        :value="option.id"
        v-model="radioButtonSelected"
        v-on:change="emitSelection(radioButtonSelected)"
      >

      <label :for="'radio-' + option.id">
        <span class="radio-field__icon" v-if="option.icon">
          <img class="radio-field__icon__icon" v-if="option.icon" :src="option.icon">
        </span>
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<script>

// import Thumb from '../assets/thumb.svg'

export default {
  name: 'RadioForm',
  components: {
    
  },
  props: {
    questionOptions: Array,
    selected: Number,
  },
  model: {

  },
  watch: {

  },
  computed: {
    
  },
  methods: {
    emitSelection: function (selection) {
      this.$emit('answerSelected', selection)
    }
  },
  data: function () {
    return {
      radioButtonSelected: null
    }
  }
}
</script>